import { UAParser } from 'ua-parser-js';

export enum DeviceOS {
    Unknown = 0,
    Android = 1,
    IOS = 2,
    Windows = 3,
    Linux = 4,
    MacOS = 5,
    HarmonyOS = 6,
    Tizen = 7,
    Web = 8,
    Embedded = 9
}

export enum BrowserName {
    Unknown = 0,
    Chrome = 1,
    Firefox = 2,
    Edge = 3,
    Safari = 4,
    Opera = 5,
    InternetExplorer = 6,
    Brave = 7,
    Vivaldi = 8,
    SamsungBrowser = 9,
    UC = 10,              // UC Browser, older mobile browser
    Tor = 11,             // Anonymous Tor browser
    AndroidWebView = 12   // In-app Android browser
}

const parser = new UAParser();

export const getDeviceOS = (): DeviceOS => {
    const osName = parser.getOS().name?.toLowerCase() || "";

    if (osName.includes("android")) return DeviceOS.Android;
    if (osName.includes("ios")) return DeviceOS.IOS;
    if (osName.includes("windows")) return DeviceOS.Windows;
    if (osName.includes("linux")) return DeviceOS.Linux;
    if (osName.includes("mac")) return DeviceOS.MacOS;

    return DeviceOS.Unknown;
};

export const getBrowserName = (): BrowserName => {
    const browserName = parser.getBrowser().name?.toLowerCase() || "";

    if (browserName.includes("chrome")) return BrowserName.Chrome;
    if (browserName.includes("firefox")) return BrowserName.Firefox;
    if (browserName.includes("edge")) return BrowserName.Edge;
    if (browserName.includes("safari")) return BrowserName.Safari;
    if (browserName.includes("opera") || browserName.includes("opr")) return BrowserName.Opera;
    if (browserName.includes("ie")) return BrowserName.InternetExplorer;
    if (browserName.includes("brave")) return BrowserName.Brave;
    if (browserName.includes("vivaldi")) return BrowserName.Vivaldi;
    if (browserName.includes("samsung")) return BrowserName.SamsungBrowser;
    if (browserName.includes("uc")) return BrowserName.UC;
    if (browserName.includes("tor")) return BrowserName.Tor;

    return BrowserName.Unknown;
};

export const getUserDeviceInfo = (): string => {
    const parser = new UAParser();
    const device = parser.getDevice();
    const os = parser.getOS();
  
    const deviceType = device.type || "desktop"; // mobile / tablet / console / smarttv / wearable / embedded
    const vendor = device.vendor || "";
    const model = device.model || "";
  
    if (deviceType === "mobile" || deviceType === "tablet") {
      return `${vendor} ${model}`.trim() || "Mobile Device";
    }
  
    if (deviceType === "desktop") {
      if (os.name?.toLowerCase().includes("windows")) return "Windows Desktop";
      if (os.name?.toLowerCase().includes("mac")) return "MacOS Desktop";
      if (os.name?.toLowerCase().includes("linux")) return "Linux Desktop";
  
      return "Desktop Device";
    }
  
    return "Unknown Device";
  };
